import { ethers } from "ethers";
import FunooniCollection from "../contracts/FunooniCollection/FunooniCollection.json";
import FunooniMarket from "../contracts/FunooniMarket/FunooniMarketplace.json";
import FunooniMarket2 from "../abis/FunooniCollection2.json";
import FunooniArchiveCollection from "../contracts/FunooniArchiveCollection/FunooniArchiveStorage.json";
import FunooniAccessKey from "./FunooniAccessKey/FunooniAccessKey.json";
import FunooniArchiveMarket from "./FunooniArchiveMarket.json";
import FunooniGlobalMarket from "./FunooniGlobalMarket/FunooniGlobalMarket.json";

export const getContractCollection = (signerOrProvider, contractAddress) => {
  return new ethers.Contract(
    contractAddress,
    FunooniCollection.abi,
    signerOrProvider,
  );
};

export const getContractMarket = (singerOrProvider, contractAddress) => {
  return new ethers.Contract(
    contractAddress,
    FunooniMarket.abi,
    singerOrProvider,
  );
};

export const COLLECTION_ABI = FunooniCollection.abi;
export const COLLECTION_BYTECODE = FunooniCollection.bytecode;
export const MARKET_ABI = FunooniMarket.abi;
export const MARKET_ABI2 = FunooniMarket2.abi;
export const MARKET_BYTECODE = FunooniMarket.bytecode;

export const ARCIVE_ABI = FunooniArchiveCollection.abi;
export const ARCIVE_BYTECODE = FunooniArchiveCollection.bytecode;

export const ACCESS_KEY_ABI = FunooniAccessKey.abi;
export const ACCESS_KEY_BYTECODE = FunooniAccessKey.bytecode;

export const ARCHIVE_MARKET_ABI = FunooniArchiveMarket.abi;
export const ARCHIVE_MARKET_BYTECODE = FunooniArchiveMarket.bytecode;

export const EGYPT_MARKET_ABI = FunooniGlobalMarket;
export const EGYPT_MARKET_ADDRESS =
  "0x0DD4D220893394b2f34a9dd00Ea7506304843F6E";
